import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { api } from "@/lib/api";

export default function Testimonials() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/testimonials").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <section data-testid="testimonials-section" className="section bg-ivory">
      <div className="container-max">
        <div className="grid grid-cols-12 gap-8 mb-14">
          <div className="col-span-12 md:col-span-6">
            <p className="overline">— Paroles confiées</p>
            <h2 className="font-display font-light text-5xl md:text-7xl leading-[0.95] tracking-tighter mt-6">
              <em className="italic text-terracotta">98%</em> de clients qui nous recommandent.
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-line">
          {items.map((t, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: i * 0.05 }}
              className="bg-bone p-10 md:p-14 flex flex-col gap-6"
              data-testid={`testimonial-${i}`}
            >
              <Quote className="w-8 h-8 text-terracotta" />
              <blockquote className="font-display text-2xl md:text-3xl leading-snug text-ink">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-auto flex items-center gap-4 pt-6 border-t border-line">
                <div className="w-12 h-12 bg-ink text-bone flex items-center justify-center font-display text-xl">
                  {t.name.charAt(0)}
                </div>
                <div>
                  <p className="font-display text-xl">{t.name}</p>
                  <p className="overline text-ink/50 mt-1">{t.role}</p>
                </div>
                <div className="ml-auto font-mono text-sm text-terracotta">
                  {"★".repeat(t.rating)}
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
